import HeaderStyle from './Header.module.css'

const Header = () => {
  return (
    <header>
        <h1>Welcome</h1>
    </header>
  )
}

export default Header